import { combineReducers } from '@ngrx/store';
import * as fromCemexPumpingService from './specification/cemex-pump.reducer';
import * as fromContracts from './specification/contract.reducer';
import * as fromHolidays from './specification/load-holidays.reducer';
import * as fromSelectedContract from './specification/master-contract.reducer';
import * as fromNextWorkingDay from './specification/next-working-day.reducer';
import * as fromPaymentTerm from './specification/payment-term.reducer';
import * as fromProductCatalog from './specification/product-catalog.reducer';
import * as fromProductPlants from './specification/product-plants.reducer';
import * as fromProductUnits from './specification/product-unit.reducer';
import * as fromSpecForm from './specification/specification.reducer';
import * as fromTimeWindows from './specification/time-windows.reducer';
import * as fromVehicles from './specification/vehicle.reducer';
import * as fromOwnfreightPlants from './specification/ownfreight-plants.reducer';
import * as fromQuantity from './specification/quantity.reducer';

export interface SpecificationBaseState {
  productUnits: fromProductUnits.State;
  specificationForm: fromSpecForm.SpecificationFormState;
  paymentTerm: fromPaymentTerm.PaymentTermState;
  deliveryTimeWindows: fromTimeWindows.TimeWindowsState;
  productCatalog: fromProductCatalog.ProductCatalogState;
  contracts: fromContracts.ContractState;
  masterContract: fromSelectedContract.MasterContractState;
  productPlants: fromProductPlants.ProductPlantsState;
  vehicles: fromVehicles.VehicleState;
  nextWorkingDay: fromNextWorkingDay.State;
  disabledDates: fromHolidays.HolidaysState;
  cemexPumpingService: fromCemexPumpingService.CemexPumpState;
  ownfreightPlants: fromOwnfreightPlants.OwfreightPlantsState;
  quantity: fromQuantity.QuantityState;
}

export const reducers = combineReducers({
  productUnits: fromProductUnits.reducer,
  specificationForm: fromSpecForm.specificationFormReducer,
  paymentTerm: fromPaymentTerm.paymentTermFormReducer,
  deliveryTimeWindows: fromTimeWindows.timeWindowsReducer,
  productCatalog: fromProductCatalog.productCatalogReducer,
  contracts: fromContracts.contractReducer,
  masterContract: fromSelectedContract.masterContractReducer,
  productPlants: fromProductPlants.productPlantsReducer,
  vehicles: fromVehicles.vehicleReducer,
  nextWorkingDay: fromNextWorkingDay.reducer,
  disabledDates: fromHolidays.reducer,
  cemexPumpingService: fromCemexPumpingService.cemexPumpReducer,
  ownfreightPlants: fromOwnfreightPlants.ownfreightPlantsReducer,
  quantity: fromQuantity.quantityReducer,
});
